import { render } from "./Result.vue?vue&type=template&id=60011968"
import script from "./Result.vue?vue&type=script&lang=js"
export * from "./Result.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\DimmyMarcelissen\\WebstormProjects\\dividenduitkering\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__